export const queryKeys = {
  trip: (tripId: string) => ["trip", tripId] as const,
  participants: (tripId: string) => ["participants", tripId] as const,
  receipts: (tripId: string) => ["receipts", tripId] as const,
  receipt: (tripId: string, receiptId: string) =>
    ["receipt", tripId, receiptId] as const,
  balances: (tripId: string) => ["balances", tripId] as const,
  settlements: (tripId: string) => ["settlements", tripId] as const,
};
